/** What the browser remembers about signing in, beyond MSAL's own cache. Storage can be blocked; every read and write tolerates that. */
const SIGNED_OUT_KEY = 'sc-platform-admin:signed-out';
const AUTO_SIGN_IN_KEY = 'sc-platform-admin:auto-sign-in-at';
/** A second automatic trip to Microsoft this soon means it can't finish on its own. */
const AUTO_SIGN_IN_GUARD_MS = 2 * 60_000;

const read = (storage: () => Storage, key: string): string | null => {
  try {
    return storage().getItem(key);
  } catch {
    return null;
  }
};

const write = (storage: () => Storage, key: string, value: string | null): void => {
  try {
    if (value === null) storage().removeItem(key);
    else storage().setItem(key, value);
  } catch {
    // Blocked storage: the choice lasts until reload.
  }
};

/** They signed out themselves: wait for them to ask, rather than signing them straight back in. */
export const signedOutOnPurpose = (): boolean => read(() => localStorage, SIGNED_OUT_KEY) !== null;
export const rememberSignedOut = (): void => write(() => localStorage, SIGNED_OUT_KEY, '1');
export const forgetSignedOut = (): void => write(() => localStorage, SIGNED_OUT_KEY, null);

/** True once per guard window: the next automatic trip to Microsoft may go ahead. */
export const takeAutoSignInTurn = (now = Date.now()): boolean => {
  const last = Number(read(() => sessionStorage, AUTO_SIGN_IN_KEY));
  if (Number.isFinite(last) && now - last < AUTO_SIGN_IN_GUARD_MS) return false;
  write(() => sessionStorage, AUTO_SIGN_IN_KEY, String(now));
  return true;
};
